import { useLocation, useNavigate, useParams } from "react-router-dom";
import Layout from "./layout";
import Prestations from "./prestations";
import { useEffect, useState } from "react";
import {
  addSelectedPrestation,
  createRendezvous,
  getAvailableSlots,
  removeSelectedPrestation,
  selectDetailsRDV,
  setCheckedEmploye,
  setDetailsRDV,
  setEditingEmploye,
  setEditingSlotR,
  setIsEditing,
  setSelectedEmploye,
  setSelectedSlotR,
} from "../../store/slices/rendezVousSlice";
import { useDispatch } from "react-redux";
import InterventionTypeSelector from "./intervention";
import Checkbox from "../../components/inputs/checkbox";
import { useSelector } from "react-redux";
import Calendar from "../../components/Calendar";
import Employe from "./employer";
import { fetchEtablissementById } from "../../store/slices/etablissementSlice";
import { formatFrenchDate, getMondayOfCurrentWeek, isValidEmail } from "../../utils/utils";
import { toast } from "react-toastify";
import { isValidPhoneNumber } from "libphonenumber-js";
import { Helmet, HelmetProvider } from "react-helmet-async";

const InfoPrestationsStepTwo = () => {
  //const
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const  detailsRDV  = useSelector((state)=>state.rendezvous.detailsRDV);
  const { selectedSlotRdv, detailsRDV } = useSelector(
    (state) => state.rendezvous
  );
 
  const mainPrestation = useSelector(
    (state) => state.rendezvous.selectedPrestations
  );
  const etablissement = useSelector(
    (state) => state.etablissements.selectedEtablissement
  );
  const { isAuthenticated } = useSelector((state) => state.user);
  // const { creationStatus, error } = useSelector((state) => state.appointments);

  const reduxPrestations = useSelector(
    (state) => state.rendezvous.selectedPrestations
  );
  //states
  // 1. Add state to track the current week
const [currentWeekDate, setCurrentWeekDate] = useState(getMondayOfCurrentWeek(new Date()));
  const [employe, setEmploye] = useState(false); // Initialize as false
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [prestations, setPrestations] = useState(() => {
    // const mainPrestation = location?.state?.prestation;
    const complementary = mainPrestation[0]?.prestation_complementaire || [];

    return [
      ...(mainPrestation ? [{ ...mainPrestation[0], selected: true }] : []),
      ...complementary.map((p) => ({ ...p, selected: false })),
    ];
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedInterventionData, setSelectedInterventionData] =
    useState( detailsRDV || null);
  useEffect(() => {
  
    if (mainPrestation.length < 1) {
      navigate(`/choisir-prestation/${id}`);
    }
  }, []);
  useEffect(()=>{
    // console.log('detailsRDV in useEffect',detailsRDV)
    setSelectedInterventionData(detailsRDV)
  },[])
  //useEffect
  useEffect(() => {
    // console.log('detailsRDV in useEffect',detailsRDV)
    setSelectedInterventionData(detailsRDV)
    dispatch(fetchEtablissementById(id));
 
  }, []);

  //functions
  const handlePrestationAction = (prestation, action) => {
    setPrestations((prev) =>
      prev.map((p) =>
        p.id === prestation.id ? { ...p, selected: action === "add" } : p
      )
    );
    if (action === "add") {
      dispatch(addSelectedPrestation(prestation));
    } else {
      dispatch(removeSelectedPrestation({ id: prestation.id }));
    }
  };

  const proceedToNextStep = () => {
    const selectedPrestations = prestations.filter((p) => p.selected);
    navigate("/details-rdv", {
      state: {
        prestations: selectedPrestations,
        etablissement,
        selectedEmployee: employe ? selectedEmployee : null,
      },
    });
  };
  const dispatchAvailabilities = (equipe,date=null) => {
    // console.log({equipe})
    const params = new URLSearchParams();
    prestations.forEach((item) => {
      params.append("prestation_ids[]", item.id);
    });
    const mondayDate = getMondayOfCurrentWeek(new Date());
      
  // Use the explicitly passed date, or the current week date, or fallback to today
  const startDate = date?.toISOString().split("T")[0] || 
  currentWeekDate.toISOString().split("T")[0] || 
  getMondayOfCurrentWeek(new Date()).toISOString().split("T")[0];
    // const startDate = date?.toISOString().split("T")[0] || mondayDate.toISOString().split("T")[0]; // Get YYYY-MM-DD format
    const queryString = params.toString();
    // console.log({selectedEmployee})
    dispatch(
      getAvailableSlots(
        `${
          etablissement?.id
        }/available-slots?start_date=${startDate}&${queryString}${
          equipe?.id 
            ? `&equipe_id=${equipe?.id}`
            : ""
        }`
      )
    );
  };
  const handleInterventionChange = (data) => {
    // console.log('Intervention changed:', data);
    dispatch(setDetailsRDV(data)); // Mise à jour directe dans Redux
    dispatchAvailabilities();
  };

  const saveDetailsRdv = async () => {
    setIsSubmitting(true);
    // console.log('Current detailsRDV:', detailsRDV);

    // Utilisez detailsRDV au lieu de selectedInterventionData
    if(detailsRDV?.type === "onsite" && (!detailsRDV?.rue || detailsRDV?.rue === "")) {
      toast.error('Merci de renseigner une adresse de domicile');
      setIsSubmitting(false);
      return; 
    }

    if(detailsRDV?.type === "onsite" && (!detailsRDV?.valueContact || detailsRDV?.valueContact === "")) {
      toast.error('Merci de renseigner une methode de contact');
      setIsSubmitting(false);
      return; 
    }
    
    if (detailsRDV?.type === "onsite" && detailsRDV?.contact === 'telephone' 
      && !isValidPhoneNumber(detailsRDV?.valueContact)) {
      toast.warning('Numéro de téléphone invalide');
      setIsSubmitting(false);
      return;
    } 
      
    if (detailsRDV?.type === "onsite" && detailsRDV?.contact === 'email' 
      && !isValidEmail(detailsRDV?.valueContact)) {
      toast.warning('Email format invalide');
      setIsSubmitting(false);
      return;
    }

    // Pas besoin de dispatcher setDetailsRDV car c'est déjà fait
    dispatch(setIsEditing(false));
   
    if (employe) {
      dispatch(setSelectedEmploye(selectedEmployee));
      dispatch(setEditingEmploye(false));
    }

    if (selectedSlotRdv?.slot) {
      const appointmentData = {
        etablissement_id: etablissement?.id,
        service_id: mainPrestation[0]?.service_id,
        prestation_ids: prestations.filter((p) => p.selected).map((p) => p.id),
        lieu_intervention: detailsRDV?.type,
        adresse_domicile: detailsRDV?.type === "onsite" ? detailsRDV?.rue : null,
        methode_contact: detailsRDV?.contact,
        contact_info: detailsRDV?.valueContact,
        equipe_id: employe ? selectedEmployee?.id : null,
        start_time: selectedSlotRdv?.slot
          ? `${selectedSlotRdv.slot.date} ${selectedSlotRdv.slot.time}:00`
          : null,
      };
      
      navigate(`/identification/${id}`, { state: appointmentData });
    }
    setIsSubmitting(false);
  };

  const handleEmployeeChange = (equipeId) => {
    // console.log({equipeId})
    setSelectedEmployee(equipeId);
    dispatch(setSelectedEmploye(equipeId));
    dispatch(setSelectedSlotR(null));
    dispatch(setEditingSlotR(true));
    dispatchAvailabilities(equipeId);
  };

  return (
    <Layout
      currentStep={1}
      from='reservation'
      etablissement={etablissement}
      prestation={prestations.filter((p) => p.selected)}
      onNext={proceedToNextStep}
      recap={true}
      conf={true}
      btn={false}
    >
      <HelmetProvider>
          <Helmet>
                                          <title>Page réservation prestataire par service</title>
                                          <meta name="description" content="Page réservation , prendre rendez-vous avec prestataire" />
                                    
                                      </Helmet></HelmetProvider>
      <div className="mb-24">
        <Prestations
          prestations={prestations || etablissement?.services}
          buttonAction={handlePrestationAction}
        />
        <InterventionTypeSelector
          prestations={prestations}
          onInterventionChange={handleInterventionChange}
        />
       { etablissement?.equipes?.length>0 &&
        <div className="mt-16">
          <Checkbox
            id="employe"
            label="Je souhaite demander un employé en particulier"
            checked={employe}
            onChange={(e) => {
              setEmploye(e.target.checked);
              dispatch(setCheckedEmploye(e.target.checked));
              dispatch(setEditingEmploye(e.target.checked));
              dispatchAvailabilities(e.target.checked ? selectedEmployee?.id :null);

            }}
          />
        </div>
        }

        {employe && (
          <Employe
            etablissement={etablissement}
            selectedEmployee={selectedEmployee}
            handleEmployeeChange={handleEmployeeChange}
            onEdit={() => {
              dispatch(setEditingEmploye(true));
            }}
          />
        )}

        {detailsRDV?.type && (
          <div className="mt-32">
            <h3 className="grey500">Date et heure</h3>
            {selectedSlotRdv?.slot ? (
              <>
                {selectedSlotRdv.isEditing ? (
                  <>
                    {" "}
                    <p className="mt-8 grey66">
                      Dans le cas d'une prestation avec plusieurs rendez-vous,
                      vous ne réservez que la première séance sur Twyny.
                    </p>
                    <Calendar
                      onSlotSelect={(slot) => dispatch(setSelectedSlotR(slot))}
                     horaires={etablissement?.horaires}
                      dispatchAvailabilities={(equipe = selectedEmployee, date) => {
                      if (date) setCurrentWeekDate(date); // Update the week date when changed
                      dispatchAvailabilities(equipe, date);
                      }}
                      currentWeekDate={currentWeekDate} // Pass the current week date
                      reduxPrestations={reduxPrestations}
                      ets={'store'}
                    />
                  </>
                ) : (
                  <>
                    <div className="intervention flex-between mt-24">
                      <div>
                        <h5>Date du rendez-vous</h5>
                        <p className="body text-gray-500 d-flex align-items-center">
                          {" "}
                          {formatFrenchDate(selectedSlotRdv.slot.date)}{" "}
                          <span className="ellipse mx-8"></span>
                          {selectedSlotRdv.slot.time}
                        </p>
                      </div>

                      <button
                        onClick={() => {
                          dispatch(setEditingSlotR(true));
                        }}
                        className="link-blue"
                      >
                        {" "}
                        Modifier{" "}
                        <img
                          src="/images/edit.svg"
                          alt="icon edit"
                          className="ml-8"
                        />
                      </button>
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <p className="mt-8 grey66">
                  Dans le cas d'une prestation avec plusieurs rendez-vous, vous
                  ne réservez que la première séance sur Twyny.
                </p>
                <Calendar
                  onSlotSelect={(slot) => dispatch(setSelectedSlotR(slot))}
                  horaires={etablissement?.horaires}
                  ets={'store'}
                  reduxPrestations={reduxPrestations}
                  dispatchAvailabilities={(equipe = selectedEmployee, date) => {
                    if (date) setCurrentWeekDate(date); // Update the week date when changed
                    dispatchAvailabilities(equipe, date);
                  }}
                  currentWeekDate={currentWeekDate} // Pass the current week date


                />
              </>
            )}
          </div>
        )}
        <button
          type="submit"
          className="twyny-cta-primary w-100 mt-16 mb-24"
          disabled={
            // isSubmitting ||
            prestations.filter((p) => p.selected).length===0 ||
            (employe && !selectedEmployee) || 
            (detailsRDV?.type && !selectedSlotRdv?.slot)
          }
          onClick={() => {
            if (selectedSlotRdv.slot) {
              dispatch(setEditingSlotR(false)); // Disable editing mode when confirming
            }
            saveDetailsRdv();
          }}
        >
          {selectedSlotRdv?.slot && !isAuthenticated
            ? "Continuer vers l'identification"
            : selectedSlotRdv?.slot && isAuthenticated
            ? "Continuer vers l'identification"
            : "Confirmer"}
        </button>
      </div>
    </Layout>
  );
};

export default InfoPrestationsStepTwo;
